import { render, staticRenderFns } from "./chatAutoAnswer.vue?vue&type=template&id=172bcc3a&"
import script from "./chatAutoAnswer.vue?vue&type=script&lang=js&"
export * from "./chatAutoAnswer.vue?vue&type=script&lang=js&"
import style0 from "./chatAutoAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports